exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "p[data-v-0ae47852]{margin:0;padding:0}.col-center[data-v-0ae47852]{text-align:center}.invoice-row .el-col[data-v-0ae47852]{line-height:30px;text-align:center}", "", {"version":3,"sources":["/workspace/src/views/payment-manager/components/PaymentWriteOffInfo.vue"],"names":[],"mappings":"AACA,mBAAmB,SAAS,SAAS,CACpC,AACD,6BAA6B,iBAAiB,CAC7C,AACD,sCAAsC,iBAAiB,iBAAiB,CACvE","file":"PaymentWriteOffInfo.vue","sourcesContent":["\np[data-v-0ae47852]{margin:0;padding:0\n}\n.col-center[data-v-0ae47852]{text-align:center\n}\n.invoice-row .el-col[data-v-0ae47852]{line-height:30px;text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ae47852","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/payment-manager/components/PaymentWriteOffInfo.vue
// module id = 2045
// module chunks = 9 20 121